export const GRID_COLUMNS =
	'minmax(160px, 2fr) minmax(110px, 1fr) minmax(110px, 1fr) minmax(150px, 1.5fr) max-content 40px';

export const COLUMN_HEADERS = ['Email', 'First Name', 'Last Name', 'Ticket Type', 'Quantity', ''];
